<template>
    <section class="main-content pb-5">
        <div class="container-fluid">


<form class="form-horizontal form-profile fv-form fv-form-bootstrap" v-on:submit.prevent autocomplete="off">


    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h2>รหัสผ่าน</h2>
      </div>
      <div class="ibox-content">

        <div class="form-group has-feedback" v-bind:class="{ 'form-group--error': $v.credentials.old_password.$error, 'form-group--success': !$v.credentials.old_password.$invalid && $v.credentials.old_password.$dirty }" >

          <label class="col-lg-2 control-label">รหัสผ่านเดิม</label>
          <div class="col-lg-10">
            <input type="password" @input="$v.credentials.old_password.$touch()" name="old_password" class="form-control" placeholder="รหัสผ่านเดิม" id="old_password" v-model.trim="credentials.old_password" data-fv-field="old_password"><i class="form-control-feedback" data-fv-icon-for="old_password" style="display: none;"></i>
            <div class="form-group__message" v-if="!$v.credentials.old_password.$minLength && $v.credentials.old_password.$error">Passwords must be at least 8 characters.</div>
            <div class="form-group__message" v-if="$v.credentials.old_password.$error">Please enter a valid password.</div>
          </div>
        </div>

        <div class="form-group has-feedback" v-bind:class="{ 'form-group--error': $v.credentials.new_password.$error, 'form-group--success': !$v.credentials.new_password.$invalid && $v.credentials.new_password.$dirty }">
          <label class="col-lg-2 control-label">รหัสผ่านใหม่</label>
          <div class="col-lg-10">
            <input type="password" @input="$v.credentials.new_password.$touch()" name="new_password" class="form-control" placeholder="รหัสผ่านใหม่" v-model.trim="credentials.new_password" data-fv-field="new_password"><i class="form-control-feedback" data-fv-icon-for="new_password" style="display: none;"></i>
            <div class="form-group__message" v-if="!$v.credentials.new_password.$minLength && $v.credentials.new_password.$error">Passwords must be at least 8 characters.</div>
            <div class="form-group__message" v-if="$v.credentials.new_password.$error">Please enter a valid password.</div>
          </div>
        </div>

        <div class="form-group has-feedback" v-bind:class="{ 'form-group--error': $v.credentials.confirm_new_password.$error, 'form-group--success': !$v.credentials.confirm_new_password.$invalid && $v.credentials.confirm_new_password.$dirty }">
          <label class="col-lg-2 control-label">ยืนยันรหัสผ่านใหม่</label>
          <div class="col-lg-10">
            <input type="password" @input="$v.credentials.confirm_new_password.$touch()" name="confirm_new_password" class="form-control" placeholder="ยืนยันรหัสผ่านใหม่" id="confirm_new_password" v-model.trim="credentials.confirm_new_password" data-fv-field="confirm_new_password"><i class="form-control-feedback" data-fv-icon-for="confirm_new_password" style="display: none;"></i>
            <div class="form-group__message" v-if="$v.credentials.confirm_new_password.$error">Password doesn't match.</div>
          </div>
        </div>

      </div>
    </div>

    <!-- Bottom area -->
    <div class="ibox float-e-margins bottom">
      <div class="ibox-content">
        <div class="form-group">
          <div class="col-lg-offset-2 col-lg-10">
            <button class="btn btn-primary" type="submit" @click="processEditPassword()">
              <span v-if="pending"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i></span>
              <span v-else>ส่งข้อมูล</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.bottom -->
  </form>

  
  




        </div>
    </section>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import moment from 'moment'


export default {
    name: 'editpassword',
    data () {
        return {
            credentials: {
                old_password: '',
                new_password: '',
                confirm_new_password: '',
            },
            pending: false
        }
    },
    methods: {
        async processEditPassword () {
            //console.log('this credentials', this.credentials)

            if (this.$v.$invalid) { this.$v.$touch(); return }

            this.pending = true

            const { old_password, new_password, confirm_new_password } = this.credentials
            const credentials = {
                old_password,
                new_password,
                confirm_new_password,
                username: this.user.username,
            }

            //console.log('credentials', credentials)

            try {
                await this.$store.dispatch('user/userUpdate', credentials)
                this.$toasted.success('Successfully updated password.')
                
                this.credentials.old_password = ''
                this.credentials.new_password = ''
                this.credentials.confirm_new_password = ''
                this.$v.$reset()
                //this.$router.push({name: 'login'})
            } catch (error) {
                this.$toasted.error('Hmm, something you entered doesn\'t seem right.')
            } finally {
                this.pending = false
            }
        },
    },
    validations: {
        credentials: {
            old_password: {
                required,
                minLength: minLength(8)
            },
            new_password: {
                required,
                minLength: minLength(8)
            },
            confirm_new_password: {
                sameAs: sameAs('new_password')
            }
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
        }),
        lastUpdate () {
            let now = new Date()
            return moment(now).format('DD/MM/YYYY HH:mm:ss')
        },
    },
    created () {
        //console.log('user', this.user)
        this.$watch('$v', () => {
            console.log('$v changed')
        })
    },
    destroyed () {
    }
}

</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';

    .note-block {
        &__note {
            background: lighten($light-grey, 2%);
            padding: 10px;
            border-radius: 6px;
            margin-bottom: 20px;
            border: 1px solid $grey;

            &:hover {
                cursor: pointer;
                opacity: 0.8;
            }
        }
    }

</style>
